import { errorBoundary } from './UnderlyingsGrid.error';
import { UnderlyingGridLegacyComponent } from './UnderlyingsGridLegacy';

export const UnderlyingsGridLegacy = errorBoundary(UnderlyingGridLegacyComponent);
